module.exports = __webpack_public_path__ + "static/media/mica-life-natura2000-horizontal.13f819dd.png";